var map = {
	"./Facebook.png": "150a",
	"./FacebookFill.png": "5240",
	"./Linkedin.png": "bb64",
	"./LinkedinFill.png": "6bd4",
	"./Pinterest.png": "4cfe",
	"./PinterestFill.png": "968e",
	"./Text.png": "e063",
	"./TextFill.png": "3c3d",
	"./Twitter.png": "9ae7",
	"./TwitterFill.png": "4bc3",
	"./Url.png": "23bf",
	"./UrlFill.png": "1bdc",
	"./threads.png": "dff3",
	"./whatsapp.png": "680c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "91a1";